import { render, staticRenderFns } from "./ConfirmOTP.vue?vue&type=template&id=e2ec9262"
import script from "./ConfirmOTP.vue?vue&type=script&lang=js"
export * from "./ConfirmOTP.vue?vue&type=script&lang=js"
import style0 from "./ConfirmOTP.vue?vue&type=style&index=0&id=e2ec9262&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports